import React, { useEffect, useState } from "react";
import { Shield } from "lucide-react";
import { useSearchParams } from "react-router-dom";
import Manage from "../components/role_management/manager/Manage";

const PermissionManagement: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(
    searchParams.get("tab") || "role-management"
  );

  useEffect(() => {
    const tabParam = searchParams.get("tab");
    const modeParam = searchParams.get("mode");

    if (!tabParam) {
      const newParams = new URLSearchParams(searchParams);
      newParams.set("tab", "role-management");
      setSearchParams(newParams);
      setActiveTab("role-management");
    } else {
      setActiveTab(tabParam);

      //   if (tabParam !== "teams" && modeParam) {
      //     const newParams = new URLSearchParams(searchParams);
      //     newParams.delete("mode");
      //     setSearchParams(newParams);
      //   }
    }
  }, [searchParams, setSearchParams]);

  const handleTabChange = (tab: string) => {
    const newParams = new URLSearchParams(searchParams);

    // newParams.set("tab", tab);
    // if (tab !== "teams") {
    //   newParams.delete("mode");
    // }

    setSearchParams(newParams);
    setActiveTab(tab);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 p-6">
      <div className="max-w-6xl mx-auto">
        {/* Tab Navigation */}
        <div className="mb-8">
          <nav className="flex space-x-1 bg-white p-1 rounded-xl shadow-sm border border-gray-100">
            <button
              onClick={() => handleTabChange("role-management")}
              className={`flex items-center space-x-2 px-6 py-3 rounded-lg text-sm font-medium transition-all duration-200 ${
                activeTab === "role-management"
                  ? "bg-blue-600 text-white shadow-md"
                  : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
              }`}
            >
              <Shield className="w-4 h-4" />
              <span>Role Management</span>
            </button>
          </nav>
        </div>

        {/* Tab Content */}
        <div className="transition-all duration-300">
          {activeTab === "role-management" && <Manage />}
        </div>
      </div>
    </div>
  );
};

export default PermissionManagement;
